var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('stripe-elements',_vm._g({ref:"stripeElements",attrs:{"billing-details":_vm.billingDetails,"mode":"setup","render-form-on-mount":_vm.setupIntentClientSecret == null,"currency":_vm.currency,"public-key":_vm.publicKey,"wallets":_vm.wallets},on:{"stripe:ready":_vm.onStripeReady}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }